import Model from "../../Model.js";

/**
 * Represent the configuration of a rule for a forecast. The
 * subclasses represent different kinds of rules. A `RuleTemplate` is
 * responsible for associating such a rule to a cell in the forecast.
 *
 * @abstract
 */
export default class AbstractRuleModel extends Model {
	getDescription() {
		return "";
	}

	accept(visitor) {
		return visitor.visitAbstractRuleModel(this);
	}

	clone() {
		return this.constructor.materialize(this.serialize(), {});
	}

	matchesManualJournalEntry() {
		return false;
	}

	/**
	 * There are 3 main kinds of rule models: VAT, Cash conversion and
	 * Prediction. This method returns a different object for each
	 * kind.
	 */
	getKind() {
		return this.constructor;
	}

	isBeta() {
		return this.constructor.isBeta();
	}

	isPrediction() {
		return false;
	}

	isBalance() {
		return false;
	}

	isManualEntry() {
		return false;
	}

	isManualJournalEntry() {
		return false;
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.type = this.constructor.getType();

		return properties;
	}

	static isBeta() {
		return false;
	}

	static getType() {
		return this._subclassResponsibility();
	}

	static getDescriptionText() {
		return this._subclassResponsibility();
	}

	static getLabel() {
		return this._subclassResponsibility();
	}

	static rendererForRuleModels(_widget) {
		return this._subclassResponsibility();
	}
}
